if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append(
          'items[0][id]',
          this.variantIdInput.value
        );
        formData.append(
          'items[0][quantity]',
          this.form.querySelector('[name="quantity"]')?.value || 1
        );

        const addonCheckbox = document.querySelector('.js-addon-checkbox');
        if (addonCheckbox?.checked && addonCheckbox.dataset.addonVariantId) {
          formData.append(
            'items[1][id]',
            addonCheckbox.dataset.addonVariantId
          );
          formData.append(
            'items[1][quantity]',
            1
          );
        }
        
        if (this.cart) {
          formData.append(
            'sections',
            'cart-notification-product,cart-notification-button,cart-icon-bubble'
          );

          formData.append(
            'sections_url',
            window.location.pathname
          );

          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (!response.key) {
              const cart = await fetch('/cart.js').then((res) => res.json());
              const addedItem = cart.items.find(
                item => item.variant_id == this.variantIdInput.value
              );
              if (addedItem) {
                response.key = addedItem.key;
              }
            }

            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('items[0][id]'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('items[0][id]'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      if (response.sections && response.sections['cart-notification-product']) {
                        const parser = new DOMParser();

                        const html = parser.parseFromString(
                          response.sections['cart-notification-product'],
                          'text/html'
                        );

                        const products = html.querySelectorAll('.cart-item');

                        response.sections['cart-notification-product'] = 
                          `<div id="shopify-section-cart-notification-product" class="shopify-section">
                            ${Array.from(products)
                              .map(item => item.outerHTML)
                              .join('')}
                          </div>`;
                      }
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {

                // Forzar que cart-notification conozca la key antes de renderizar
                this.cart.cartItemKey = response.key;

                console.log('response key:', response.key);

                if (response.sections && response.sections['cart-notification-product']) {
                  const parser = new DOMParser();

                  const html = parser.parseFromString(
                    response.sections['cart-notification-product'],
                    'text/html'
                  );

                  const products = html.querySelectorAll('.cart-item');

                  response.sections['cart-notification-product'] = `<div id="shopify-section-cart-notification-product" class="shopify-section">
                    <div id="cart-notification-product-${response.key}">
                      ${Array.from(products)
                        .map(item => item.outerHTML)
                        .join('')}
                    </div>
                  </div>`;
                }

                console.log('Sections recibidas:', Object.keys(response.sections));

                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
